module.exports = __webpack_public_path__ + "img/main_slide_5.46aa6a09.png";